import { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/feature/Breadcrumb';
import ScrollToTop from '@/components/feature/ScrollToTop';
import CategoryTabs from '@/components/base/CategoryTabs';
import ArticleCard from '@/components/base/ArticleCard';
import { categories, getArticlesByCategory } from '@/mocks/articles';

export default function CategoryPage() {
  const { slug } = useParams<{ slug: string }>();
  const activeSlug = slug || 'plot-analysis';
  const activeCategory = categories.find((c) => c.slug === activeSlug);
  const articles = getArticlesByCategory(activeSlug);

  const schema = {
    '@context': 'https://schema.org',
    '@type': 'CollectionPage',
    name: activeCategory ? `${activeCategory.name} - 艳姆1—6系列解析` : '内容分类',
    description: activeCategory?.description || '',
    url: typeof window !== 'undefined' ? window.location.href : '',
    isPartOf: {
      '@type': 'WebSite',
      name: '艳姆1—6系列解析站',
      url: typeof window !== 'undefined' ? window.location.origin : '',
    },
  };

  const handleCategoryChange = (newSlug: string) => {
    window.REACT_APP_NAVIGATE(`/category/${newSlug}`);
  };

  if (!activeCategory) {
    return (
      <>
        <Navbar />
        <div className="pt-20 pb-16">
          <div className="max-w-7xl mx-auto px-4 md:px-6 text-center py-20">
            <h1 className="text-2xl font-heading font-bold text-foreground-950 mb-4">
              分类未找到
            </h1>
            <Link to="/" className="text-primary-600 hover:text-primary-700 text-sm">
              返回首页
            </Link>
          </div>
        </div>
        <Footer />
      </>
    );
  }

  return (
    <>
      <ScrollToTop />
      <script type="application/ld+json">{JSON.stringify(schema)}</script>
      <Navbar />
      <main className="pt-24 pb-16">
        <div className="max-w-7xl mx-auto px-4 md:px-6">
          <Breadcrumb
            items={[
              { label: '首页', href: '/' },
              { label: activeCategory.name },
            ]}
          />

          <div className="mb-10">
            <div className="flex items-center gap-3 mb-3">
              <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-accent-100 text-accent-700">
                <i className={`${activeCategory.icon} text-2xl`}></i>
              </div>
              <div>
                <h1 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
                  {activeCategory.name}
                </h1>
              </div>
            </div>
            <p className="text-foreground-600 text-sm ml-[60px]">
              {activeCategory.description}
            </p>
          </div>

          <CategoryTabs
            categories={categories}
            activeSlug={activeSlug}
            onSelect={handleCategoryChange}
          />

          <div className="mt-8">
            {articles.length > 0 ? (
              <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
                {articles.map((article) => (
                  <ArticleCard key={article.id} article={article} />
                ))}
              </div>
            ) : (
              <div className="text-center py-16">
                <p className="text-foreground-500 text-sm">该分类暂无文章</p>
              </div>
            )}
          </div>
        </div>
      </main>
      <Footer />
    </>
  );
}